import { css } from 'styled-components'

export const transitionFade = css`
  opacity: 0;
  transition: opacity ${p => p.theme.animation.timeStandard} ease-in;

  ${({ state }) =>
    state === 'entering' ||
    (state === 'entered' &&
      css`
        opacity: 1;
      `)}

  ${({ state }) =>
    state === 'exiting' ||
    (state === 'exited' &&
      css`
        opacity: 0;
      `)}
`
